import React from 'react';
import * as PropTypes from 'prop-types';

import { DROPDOWN_POSITIONS, ROLES } from '../../../constants';
import { Dropdown } from '../common/Dropdown';
import { useClickEventOnDocument } from '../../hooks/useClickEventOnDocument';
import endpoints from '../../define/endpoints';
import Avatar, { AvatarSizes } from '../Avatar/Avatar';

const UserProfileWidget = (props) => {
  const { classes, pages, user, logoutHandler } = props;
  const [isDropdownOpen, setIsDropdownOpen] = React.useState(false);

  useClickEventOnDocument([isDropdownOpen], () => {
    isDropdownOpen && setIsDropdownOpen(false);
  });

  return (
    <li className={classes} onClick={() => setIsDropdownOpen(true)}>
      <strong>
        {user.first_name ?? user.email}
        <i className={'icon-down'}>
          <Dropdown position={DROPDOWN_POSITIONS.RIGHT} isOpen={isDropdownOpen}>
            <div className={'dropdown__content'} style={{ width: 150 }}>
              {user.role === ROLES.CUSTOMER && (
                <React.Fragment>
                  {!!pages.orderList && (
                    <a href={pages.orderList} className={'header-dd-row'}>
                      {app_main_wpml.reservations}
                    </a>
                  )}
                  {!!pages.wishList && (
                    <a href={pages.wishList} className={'header-dd-row'}>
                      {app_main_wpml.favourite}
                    </a>
                  )}
                  {!!pages.profile && (
                    <a href={pages.profile} className={'header-dd-row'}>
                      {app_main_wpml.profile}
                    </a>
                  )}
                </React.Fragment>
              )}
              {user.role !== ROLES.CUSTOMER && (
                <a
                  href={window.freedomeConfig.endpoints.dashboard}
                  className={'header-dd-row'}
                >
                  {app_main_wpml.dashboard}
                </a>
              )}
              <div className={'header-dd-separator'} />
              <a className={'header-dd-row'} onClick={logoutHandler}>
                {app_main_wpml.logout}
              </a>
            </div>
          </Dropdown>
        </i>
      </strong>
      {!!user.profile_image && (
        <Avatar
          size={AvatarSizes.s}
          className={'ml-2xs'}
          profileImage={user && user.profile_image}
          firstName={user && user.first_name}
          lastName={user && user.last_name}
        />
      )}
    </li>
  );
};

UserProfileWidget.propTypes = {
  classes: PropTypes.string,
  pages: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  logoutHandler: PropTypes.func.isRequired,
};

export default UserProfileWidget;
